module.exports = __webpack_public_path__ + "img/告知性备案系统.f7ec71aa.png";